import api from '@services/api';
import { AdminContext } from '@contexts/admin_context';
import { useToast } from 'vindi-ds-components';
import { useContext } from 'react';

function useSendForm() {
  const showToast = useToast();
  const { hiddenModal } = useContext(AdminContext);

  function handleSubmit(params) {
    api.post('/admin/customer_form_data/update', params).then((success) => {
      showToast(
        success.data, {
          severity: 'success',
          position: 'topRight',
        },
      );
      hiddenModal();
    }).catch((error) => {
      showToast(
        error.response.data, {
          severity: 'error',
          position: 'topRight',
        },
      );
    });
  }

  return {
    handleSubmit,
  };
}

export default useSendForm;
